import React, { useRef } from "react";
import Pagination from "./pagination";
import classNames from "classnames";
import { DownloadTableExcel } from "react-export-table-to-excel";
import IconExportation from '../../assets/icons/iconExportation.svg'
import Spinner from "../Spinner";
import CustomSelect from "../../components/CustomSelect";
 
const Table = ({
  data,
  columns,
  withColumn,
  excel,
  openModal,
  setDataTransfert,
  loading,
  rowClassName,
  message='Aucun résultat trouvé',
  setPageSize,
  pageSize, 
  currentPage, 
  setCurrentPage,
  totalPage,
  titleTable='Gestion des Simulations',
  className='w-full min-w-max border-collapse'


}) => {
  const tableRef = useRef(null);
 
  const handlePageChange = (page) => setCurrentPage(page);

  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  if (loading) {
    return (
      <div className="flex justify-center items-center p-10">
        <Spinner width="w-[60px]" height="h-[60px]" />
      </div>
    );
  }


  const filterListeOption= options.filter((item)=>item.value <= totalPage)

  return (
    <div className="w-full relative">
      {data?.length > 0 ? (
        <>
          <div className="flex lg:flex-row flex-col gap-4 justify-between lg:items-center items-start mb-4 w-full">
            <h2 className="text-[20px] font-medium w-full text-left">{titleTable}</h2>
            {excel && (
              <div className="flex lg:justify-end lg:gap-8 items-center justify-between w-full">
                {/* <input className=" shadow-[0px_2px_10px_rgba(0,0,0,0.1)] flex items-center justify-center placeholder:text-center rounded-[8px] text-[12px] px-4 w-[90px] h-[32px] outline-none" placeholder="Filtres" /> */}
                <DownloadTableExcel filename="export_data" sheet="sheet1" currentTableRef={tableRef.current}>
                <button className=" border  border-[#34C759] text-[#34C759] hover:text-[#34C759]/60 h-[32px] px-4 rounded-[8px] flex items-center gap-4 text-sm font-bold transition-all shadow-[0_2px_10px_rgba(52,199,89,0.1)]">
                  Exporter en Excel <img src={IconExportation} width={16} height={16} alt="exportation de table"/>
                </button>
                </DownloadTableExcel>

              </div>
              
            )}
          </div>

          <div className="w-full overflow-x-auto pt-4 rounded-lg shadow-sm">
            {/* <table className=" w-full min-w-max border-collapse" ref={tableRef}> */}
            <table className={`${className}`}  ref={tableRef}>
              <thead>
                <tr className="">
                  {columns?.map((column) => (
                    <th key={column.key} className="p-3 text-[#000000] text-[12px] font-semibold text-left whitespace-nowrap">
                      {column?.label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="bg-white">
                {data?.map((row, index) => {
                  const isEven = index % 2 !== 0;
                  const customClass = rowClassName ? rowClassName(row) : "";

                  return (
                    <tr
                      key={row?._id || index}
                      className={classNames(
                        "transition-colors cursor-pointer group  border-b-[1px] border-[#EEEEEE]  ",
                         isEven ? "bg-white" : " bg-[#F6F6F6]",
                        customClass
                      )}
                      onClick={() => {
                        if (openModal) openModal();
                        if (setDataTransfert) setDataTransfert(row);
                      }}
                    >
                      {columns?.map((column) => (
                        <td key={column.key} className="p-3 text-left text-[14px] whitespace-nowrap ">
                          {/* whitespace-nowrap */}
                          {column?.customRenderers ? column?.customRenderers(row) : row[column.key]} 
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

           {currentPage && 
            <div className="flex justify-between items-center mt-4 w-full ">
              <div className="flex-1">
                <Pagination currentPage={currentPage} pageSize={pageSize} totalCount={totalPage} onPageChange={handlePageChange} />
            </div>
            <div className=" flex items-center gap-3 justify-end ">
              <span className="text-[#AEB6FB] text-[12px]">Afficher par</span>
              <CustomSelect
                styleInput='w-[100px] h-[32px] rounded-[4px]'
                value={pageSize}
                onChange={(val) => setPageSize(Number(val), setCurrentPage(1))} 
                options={filterListeOption}
                totalPage={totalPage}
              />
            </div>

            </div>
            }
        </>
      ) : (
        <div className="w-full text-center py-10 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200 text-gray-400">
          {message}
        </div>
      )}
    </div>
  );
};

export default Table;